import {scroller} from './scroller';
export function artistTrigger() {
  $('.js-artist-trigger').on('click', function() {
    const $this = $(this);
    const thisTop = $this.offset().top;
    const $thisArtist = $this.closest('.js-artist');
    const $artist = $('.js-artist');

    if($thisArtist.hasClass('is-active')) {
      $artist.removeClass('is-active');
    } else {
      $artist.removeClass('is-active');
      $thisArtist.addClass('is-active');
    }

    const $currentArtist = $('.js-artist.is-active');
    const headerHeight = $('#header-nav').outerHeight(true);
    const scrollNavHeight = $('.js-scroll-nav-placeholder').height();
    let scrollTarget = 0;
    let minus = 0;

    if($(window).width() >= 768) {
      if(IS_TOUCH) {
        minus = 0;
      } else {
        minus = headerHeight + scrollNavHeight;
      }
    } else {
      minus = 50;
    }

    if($currentArtist[0]) {
      const currentTop = $currentArtist.offset().top;
      scrollTarget = currentTop - minus;
      scroller(scrollTarget, 1200, 'easeInOutExpo');
    } else {
      scrollTarget = thisTop - minus;
      scroller(scrollTarget, 0, 'easeInOutExpo');
    }
    
    return false;
  });
}